// src/badiu-editor-lib.js
//
// Entry point do bundle do Badiu Editor.
//
// O build (npm run build) compila este arquivo como IIFE e gera
// dist/badiu-editor-lib.js expondo window.BadiuEditor com:
//
//   window.BadiuEditor.BadiuTiptapEditor   → componente Vue pronto para registro
//   window.BadiuEditor.install(app)        → Vue plugin (app.use)
//
// O que ENTRA no bundle:
//   - Todos os arquivos .vue do editor (BadiuTiptapEditor e sub-componentes)
//   - Todas as bibliotecas Tiptap
//
// O que FICA FORA (externo, fornecido pelo host):
//   - vue   → window.BADIUNET_SYSTEM_CORE_VENDOR.Vue
//   - axios → window.BADIUNET_SYSTEM_CORE_VENDOR.axios

import BadiuTiptapEditor from './components/editor/BadiuTiptapEditor.vue'

const BadiuEditor = {
  BadiuTiptapEditor,

  /** Registra BadiuTiptapEditor globalmente. Uso: app.use(window.BadiuEditor) */
  install(app) {
    app.component('BadiuTiptapEditor', BadiuTiptapEditor)
  }
}

// Garante acesso via window mesmo se o IIFE wrapper não exportar o default.
window.BadiuEditor = BadiuEditor

export default BadiuEditor
